import { Component, Input, OnChanges } from "@angular/core";

@Component({
  selector: "ab-route-name",
  templateUrl: "./route-name.component.html",
})
export class RouteNameComponent implements OnChanges {
  @Input() public routeName: string | any[];

  public meta: string;
  public name: string;
  public engine: string;
  private META_PATTERN = /(\(.*\))/;
  private ENGINE_PATTERN = /^(.*)#/;

  public ngOnChanges() {
    this.render();
  }

  private render() {
    if (!this.routeName) {
      return;
    }
    if (typeof this.routeName !== "string") {
      return;
    }

    this.meta = (this.routeName.match(this.META_PATTERN) || [])[0];
    this.engine = (this.routeName.match(this.ENGINE_PATTERN) || [])[1];

    this.name = this.routeName
      .replace(this.META_PATTERN, "")
      .replace(this.ENGINE_PATTERN, "");
  }
}
